<div class="its-course-catalogue-coursecard__enrolled-status"> 
    <div class="its-course-catalogue-coursecard__enrolled-status-icon"></div>
    <div class="its-course-catalogue-coursecard__enrolled-status-text" aria-label="{lang.main('Course_card_enrolled_label')}">{lang.main('Course_card_enrolled_status')}</div>
</div>

<script>
    import { lang } from "@its-ui/mono/lang/provider";
</script>
